import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from '@/router'
import { goPC } from '@/pcRedirect'
import sensors from 'sa-sdk-javascript'

Vue.use(VueRouter)
localStorage.removeItem('currentTitle')
localStorage.removeItem('lastTitle')
var routes = Router.routes;
let router = null;

const url = new URL(location.href);
if(/^\/hr\/.*$/.test(url.pathname)) {
    router = new VueRouter({
        base: '/hr',
        mode: 'history',
        routes
    })
} else {
    router = new VueRouter({
        // mode: 'hash',
        routes
    })
}


router.beforeEach((to, from, next) => {
    // console.log(routes);
    goPC(to, from, next)
    // MedSeek App 内访问工具聚合页时重定向到专属页面，避免 DoctorToolsIndex 生命周期和埋点触发
    if (window.ISMEDSEEKAPP && to.path === '/tools/DoctorToolsIndex') {
        return next({ path: '/tools/MedSeekToolsIndex', query: to.query })
    }
    var match = routes.filter(function(e) {
        //alert(to.path);
        // console.log('path=>'+to.path+'[name]=>'+to.name+'[e.name]=>'+e.name);
        if (e.children && e.children.length) {
            let ischildren = false;
            for (let i = 0; i < e.children.length; i++) {
                let ch = e.children[i];
                if (ch.name == to.name) {
                    ischildren = true;
                }
            }
            if (ischildren) {
                return true;
            }
        }
        return e.name == to.name;
    });

    globalstore.commit('CLOSE_POPUP');

    // 设置标题
    if (match[0].children && match[0].children.length) {
        let mt = match[0].children.filter(function(e) {
            return e.name == to.name;
        });
        // console.log(mt);
        document.title = mt[0].title;
    } else {
        document.title = match[0].title;
    }
    if(localStorage.getItem('currentTitle')){
      localStorage.setItem('lastTitle',localStorage.getItem('currentTitle'))
      localStorage.setItem('currentTitle',document.title)
    }else if(localStorage.getItem('lastTitle')){
      localStorage.setItem('currentTitle',document.title)
    }else{
      localStorage.setItem('lastTitle',document.title)
    }

    /** 置灰指定专栏和专栏下文章
    let toroute = to;
    if((toroute.name == "column" && toroute.params.id == "1573")
       || ((toroute.name == "doc" || toroute.name == "live") && (
            toroute.params.id == "88004"
            || toroute.params.id == "88000"
            || toroute.params.id == "81475"
            || toroute.params.id == "82562"
            || toroute.params.id == "80154"
            || toroute.params.id == "75876"
            || toroute.params.id == "72447"
            || toroute.params.id == "72696"
            || toroute.params.id == "72394"
            || toroute.params.id == "67771"
            || toroute.params.id == "65914"
            || toroute.params.id == "60550"
            || toroute.params.id == "53889"
            || toroute.params.id == "40132"
            || toroute.params.id == "47396"
            || toroute.params.id == "46963"
            || toroute.params.id == "45912"
            || toroute.params.id == "42924"
            || toroute.params.id == "40130"
            || toroute.params.id == "39474"
            || toroute.params.id == "38527"
       ))
    ) {

    }else {
        let body = document.body;
        body.classList.remove("global-gray-filter");
    }*/

    next()
})

router.afterEach(route => {
    // ...
    if (route.name !== 'Index' && route.name !== 'Vote2021' &&  route.name!=='ClinicalGuideSelect' && route.name !== 'HkjActivityHomePage' && route.name != 'activityHomePage' && route.name != 'activityJYJhome' && route.name !== 'CreditMallOrderList'&& route.name !== 'Vote2022'&& route.name !== 'AILiterature'&& route.name !== 'AILiteratureSearch'&& route.name !== 'AILiteratureList'&& route.name !== 'AILiteratureCollect'&& route.name !== '2025CmmHomeSub') {
        console.log('index.js------scroll---routename:',route.name)
        setTimeout(function() {
            window.scrollTo(0, 0);
        }, 300);
    }
    if ((route.name == 'activityJYJ2023' || route.name == 'activityJYJ2024') && browser.versions.ios && window.is_app()) {
        localStorage.setItem('jyj_index', 0)
    }

    // 页面级 PV 上报策略（仅依据路由 meta.pageViewStrategy，未配置时默认使用全局上报）
    // 可选取值：
    // - 'global'：使用路由层的全局 $pageView 上报
    // - 'component'：由组件内部按业务时机上报，路由层不触发
    // - 'none'：不做页面级上报（如预览/容器页）

    // 仅读取路由 meta 的策略；未配置时回落为 'global'
    const pageViewStrategy = (route && route.meta && route.meta.pageViewStrategy) || 'global'

    // 3) 初始化是否发送页面离开事件
    // - global：默认发送（true）
    // - component/none：默认不发送（由组件在具备访问权限时再置为 true）
    window.pageLeaveIsCollect = pageViewStrategy === 'global'

    // 4) 根据策略决定是否在路由层触发 $pageView
    if (pageViewStrategy === 'global') {
        Vue.nextTick(() => {
            sensors.quick('autoTrackSinglePage')
        })
    }

    /** 置灰指定专栏和专栏下文章
    let toroute = route;
    if((toroute.name == "column" && toroute.params.id == "1573")
       || ((toroute.name == "doc" || toroute.name == "live") && (
            toroute.params.id == "88004"
            || toroute.params.id == "88000"
            || toroute.params.id == "81475"
            || toroute.params.id == "82562"
            || toroute.params.id == "80154"
            || toroute.params.id == "75876"
            || toroute.params.id == "72447"
            || toroute.params.id == "72696"
            || toroute.params.id == "72394"
            || toroute.params.id == "67771"
            || toroute.params.id == "65914"
            || toroute.params.id == "60550"
            || toroute.params.id == "53889"
            || toroute.params.id == "40132"
            || toroute.params.id == "47396"
            || toroute.params.id == "46963"
            || toroute.params.id == "45912"
            || toroute.params.id == "42924"
            || toroute.params.id == "40130"
            || toroute.params.id == "39474"
            || toroute.params.id == "38527"
       ))
    ) {
        let body = document.body;
        body.classList.add("global-gray-filter");
    }*/

})

export default router
